import React, {Component} from 'react';

interface ClientType {
    client_name: string;
}

interface ClientsType {
    clients: ClientType[];
}

interface ProjectType {
    site_client: string;
}

interface ProjectssType {
    projects: ProjectType[];
}

export default class Test extends Component {
    render() {
        return (
            <Clients clients={this.state.clients} />
        )
    }

    state = {
        clients: [],
        projects: []
    };

    componentDidMount() {
        if(!this.state.clients.length) {
            fetch('https://2021.apagecode.com/feed.json')
                .then(res => res.json())
                .then((data) => {
                    this.setState({ clients: data.clients, projects: data.projects })
                })
                .catch(console.log)
        }
    }
}

function decodeHtml(html: string) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

const Clients = ({clients} : ClientsType) => {
    try{
        return (
            <div>
                <h1>Client List</h1>
                {clients.map((client) => (
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">{decodeHtml(client.client_name)}</h5>
                        </div>
                    </div>
                ))}
            </div>
        )
    } catch(e){
        return (
            <>{JSON.stringify(clients)}</>
        );
    }
};

const Projects = ({projects} : ProjectssType) => {
    try{
        return (
            <div>
                <h1>Project List</h1>
                {projects.map((project) => (
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">{project.site_client}</h5>
                        </div>
                    </div>
                ))}
            </div>
        )
    } catch(e){
        return (
            <>{JSON.stringify(projects)}</>
        );
    }
};
